import React, { useEffect, useState } from "react";
import { useAuthContext } from "../../hooks/useAuthContext";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { ApiConnectionString } from "../../constants/ApiConntection";
import LoadingSpinner from "../../components/LoadingSpinner";
import "./EditClub.css"
import ClubUpdatedModal from "./ClubUpdatedModal";

export default function EditClub() {
  const [staticName, setStaticName] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [website, setWebsite] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [county, setCounty] = useState("");
  const [postCode, setPostCode] = useState("");
  const [description, setDescription] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [facebook, setFaceBook] = useState("");
  const [twitter, setTwitter] = useState("");
  const [instagram, setInstagram] = useState("");
  const [linkedin, setLinkedin] = useState("");
  const [tikTok, setTiktok] = useState("");

  const [nameErr, setNameErr] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [phoneNumberErr, setPhoneNumberErr] = useState("");
  const [websiteErr, setWebsiteErr] = useState("");
  const [addressErr, setAddressErr] = useState("");
  const [cityErr, setCityErr] = useState("");
  const [countyErr, setCountyErr] = useState("");
  const [postCodeErr, setPostCodeErr] = useState("");
  const [descriptionErr, setDescriptionErr] = useState("");
  const [country,setCountry] = useState("")
  console.log(country)

  const [clubUpadedModal, setClubUpdatedModal] = useState(false);

  const { user,dispatch } = useAuthContext();
  const { id } = useParams();

  const [isLoading, setIsLoading] = useState(false);

  const navi = useNavigate();

  const regex = /^[A-Za-z0-9 ]*$/; // Allows letters, numbers, and spaces

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const clubResponse = await axios.get(
        `${ApiConnectionString}/api/club/${id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (clubResponse.status === 200) {
        const data = clubResponse.data;
        setName(data.name);
        setStaticName(data.name);
        setEmail(data.email);
        setPhoneNumber(data.phoneNumber);
        setWebsite(data.website);
        setAddress(data.address);
        setCity(data.city);
        setCounty(data.county);
        setCountry(data.country)
        setPostCode(data.postCode);
        setDescription(data.description);
        setSubtitle(data.subtitle);
        setFaceBook(data.facebook);
        setTwitter(data.twitter);
        setInstagram(data.instagram);
        setLinkedin(data.linkedin);
        setTiktok(data.tikTok);
      }
    } catch (error) {
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      console.error("Error fetching club data:", error);
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
 
    let timeout;

    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
        // Add your fallback logic here
      }, 3000); // Delay of 3 seconds before executing the else logic
    }

    return () => clearTimeout(timeout); // Cleanup timeout on re-run
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setNameErr("");
    setEmailErr("");
    setPhoneNumberErr("");
    setWebsiteErr("");
    setAddressErr("");
    setCityErr("");
    setCountyErr("");
    setPostCodeErr("");
    setDescriptionErr("");
    setIsLoading(true);
    let error = false;

    // Name Validations
    if (!regex.test(name)) {
      error = true;
      setNameErr("Name can only contain letters, numbers, and spaces.");
    }
    if (name.length > 60) {
      error = true;
      setNameErr("Name is too long");
    }
    //Email validation
    if (email) {
      if (email.length > 300) {
        error = true;
        setEmailErr("Email is too long");
      }
    }
    if (phoneNumber) {
      if (phoneNumber.length > 300) {
        error = true;
        phoneNumberErr("Phone number is too long");
      }
    }
    if (website) {
      if (website.length > 300) {
        error = true;
        websiteErr("Phone number is too long");
      }
    }
    if (address) {
      if (city.address > 300) {
        error = true;
        addressErr("City is too long");
      }
    }
    if (city) {
      if (city.length > 300) {
        error = true;
        cityErr("City is too long");
      }
    }
    if (county) {
      if (county.length > 300) {
        error = true;
        countyErr("County is too long");
      }
    }
    if (postCode) {
      if (postCode.length > 50) {
        error = true;
        postCodeErr("Postcode is too long");
      }
    }
    if (description.length > 3000) {
      error = true;
      description("description is too long");
    }
    try {
      if (!error) {
        if (name != staticName) {
          const checkClubExistsResponse = await axios.get(
            `${ApiConnectionString}/api/Club/GetByName/${name.replaceAll(
              " ",
              ""
            )}`
          );

          if (checkClubExistsResponse.data.id != 0) {
            error = true;
            setNameErr("This name already exists");
          }
        }
      }

      if (!error) {
        const clubDetails = {
          id,
          name,
          email,
          phoneNumber,
          website,
          address,
          city,
          county,
          postCode,
          description,
          facebook,
          twitter,
          instagram,
          linkedin,
          tikTok,
          subtitle,
        };

        const updateResponse = await axios.put(
          `${ApiConnectionString}/api/club`,
          clubDetails,
          {
            headers: { Authorization: `Bearer ${user.token}` },
          }
        );

        if (updateResponse.status == 200) {
          setClubUpdatedModal(true);
        }
      }
    } catch (error) {
      console.error("An error occurred:", error);
      // Handle the error state here, e.g., set error messages or state
      setNameErr("An unexpected error occurred. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };
  if (isLoading) {
    return <LoadingSpinner />;
  } else {
    return (
      <div className="container">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col">
              <div className="customNav">
                <p className="p-2 fw-bold">Main Info</p>
              </div>
  
              <table>
                <tbody>
                  <tr>
                    <th>
                      <span>Name:</span>
                    </th>
                    <td>
                      <input
                        value={name}
                        onChange={(e) =>
                          setName(e.target.value.replace(/\s+/g, " "))
                        }
                        maxLength={100}
                        required
                      />
                    </td>
                  </tr>
                  {nameErr && <p className="text-danger mx-5">{nameErr}</p>}
  
                  <tr>
                    <th>
                      <span>Subtitle:</span>
                    </th>
                    <td>
                      <input
                        value={subtitle}
                        onChange={(e) => setSubtitle(e.target.value)}
                        maxLength={120}
                        required
                      />
                    </td>
                  </tr>
  
                  <tr>
                    <th>
                      <span>Descritpion:</span>
                    </th>
                    <td>
                      <textarea
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        rows={4} // You can adjust the number of rows as needed
                        cols={50} // You can adjust the number of columns as needed
                        maxLength={1500}
                      />
                    </td>
                  </tr>
                  {descriptionErr && (
                    <p className="text-danger mx-5">{descriptionErr}</p>
                  )}
  
                  <tr>
                    <th>Website:</th>
                    <td>
                      <input
                        value={website}
                        onChange={(e) => setWebsite(e.target.value)}
                      />
                    </td>
                  </tr>
                  <p className="text-muted">
                    Leave this field blank if you prefer not to display this
                    information publicly.
                  </p>
                  {websiteErr && <p className="text-danger mx-5">{websiteErr}</p>}
                  <tr>
                    <th>Phone Number:</th>
                    <td>
                      <input
                        type="tel"
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                      />
                    </td>
                  </tr>
                  <p className="text-muted">
                    Leave this field blank if you prefer not to display this
                    information publicly.
                  </p>
                  {phoneNumberErr && (
                    <p className="text-danger mx-5">{phoneNumberErr}</p>
                  )}
                  <tr>
                    <th>Email:</th>
                    <td>
                      <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </td>
                  </tr>
                  <p className="text-muted">
                    Leave this field blank if you prefer not to display this
                    information publicly.
                  </p>
                  {emailErr && <p className="text-danger mx-5">{emailErr}</p>}
                </tbody>
              </table>
            </div>
            <div className="col">
              <div className="customNav">
                <p className="p-2 fw-bold">Address</p>
              </div>
              <table>
                <tbody>
                  <tr>
                    <th>
                      <span>Address:</span>
                    </th>
                    <td>
                      <textarea
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        rows={4}
                        cols={50}
                        required
                      />
                    </td>
                  </tr>
                  {addressErr && <p className="text-danger mx-5">{addressErr}</p>}
                  <tr>
                    <th>City or Town:</th>
                    <td>
                      {" "}
                      <input
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                      />
                    </td>
                  </tr>
                  {cityErr && <p className="text-danger mx-5">{cityErr}</p>}
                  <tr>
                    <th>{
  country === "" 
    ? "County/State/Province" 
    : country === "US" 
    ? "State" 
    : country === "CA" 
    ? "Province" 
    : country === "UK" 
    ? "County" 
    : country === "AU" 
    ? "State/Territory" 
    : "County/State/Province"
}:</th>
                    <td>
                      {" "}
                      <input
                        value={county}
                        onChange={(e) => setCounty(e.target.value)}
                        required
                      />
                    </td>
                  </tr>
                  {countyErr && <p className="text-danger mx-5">{countyErr}</p>}
                  <tr>
                    <th> {country === "UK"
    ? "Postcode"
    : country === "US"
    ? "ZIP Code"
    : country === "AU"
    ? "Postcode"
    : country === "CA"
    ? "Postal Code"
    : "Postal Code"}:</th>
                    <td>
                      {" "}
                      <input
                        value={postCode}
                        onChange={(e) => setPostCode(e.target.value)}
                        required
                      />
                    </td>
                  </tr>
                  {postCodeErr && (
                    <p className="text-danger mx-5">{postCodeErr}</p>
                  )}
                </tbody>
              </table>
            </div>
            <div className="col">
              <div className="customNav">
                <p className="p-2 fw-bold">Social Media</p>
              </div>
              <table>
                <tbody>
                  <tr>
                    <th>
                      <span>Facebook</span>
                    </th>
                    <td>
                      <input
                        value={facebook}
                        onChange={(e) => setFaceBook(e.target.value)}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <span>Twitter</span>
                    </th>
                    <td>
                      <input
                        value={twitter}
                        onChange={(e) => setTwitter(e.target.value)}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <span>Instagram</span>
                    </th>
                    <td>
                      <input
                        value={instagram}
                        onChange={(e) => setInstagram(e.target.value)}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <span>Linkedib</span>
                    </th>
                    <td>
                      <input
                        value={linkedin}
                        onChange={(e) => setLinkedin(e.target.value)}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <span>TikTok</span>
                    </th>
                    <td>
                      <input
                        value={tikTok}
                        onChange={(e) => setTiktok(e.target.value)}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
  
          <div className="d-flex justify-content-center">
            <button className="ec-red-button  mb-3"><a className="fw-bold">Save Changes</a></button>
          </div>
        </form>
        {clubUpadedModal && <ClubUpdatedModal id={id} />}
      </div>
    );
  }


}
